class ViewAsSelector extends HTMLElement {
  constructor() {
    super();
    this.buttons = Array.from(this.querySelectorAll('.view-as__button'));
  }

  connectedCallback() {
    this.productGrid = document.getElementById('product-grid');
    if (!this.productGrid) return;

    this.context = this.dataset.context === 'mobile' ? 'mobile' : 'desktop';
    this.classPrefix = this.context === 'mobile' ? 'view-as-mobile-' : 'view-as-';
    this.storageKey = `viewAsPreference-${this.context}`;
    this.mediaQuery = this.context === 'mobile' ? '(max-width: 749px)' : '(min-width: 990px)';

    const saved = localStorage.getItem(this.storageKey);
    const initial = saved || this.dataset.defaultColumns || '4';

    if (window.matchMedia(this.mediaQuery).matches) {
      this.applyView(initial, false);
    } else {
      this.highlightActive(initial);
    }

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.applyView(button.dataset.view, true);
      });
    });
  }

  applyView(view, persist) {
    if (!this.productGrid) return;

    const allClasses = this.buttons.map((button) => `${this.classPrefix}${button.dataset.view}`);
    this.productGrid.classList.remove(...allClasses);
    this.productGrid.classList.add(`${this.classPrefix}${view}`);

    const cards = this.productGrid.querySelectorAll('.card');

    if (view === 'list') {
      cards.forEach((card) => card.classList.add('card--horizontal'));
    } else {
      cards.forEach((card) => card.classList.remove('card--horizontal'));
    }

    this.highlightActive(view);

    if (persist) {
      localStorage.setItem(this.storageKey, view);
    }
  }

  highlightActive(view) {
    this.buttons.forEach((button) => {
      const isActive = button.dataset.view === view;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-pressed', isActive);
    });
  }
}

customElements.define('view-as-selector', ViewAsSelector);
